import React from 'react';
import CompaniesList from './components/CompaniesList';

const CompaniesView = () => (
  <CompaniesList />
);

export default CompaniesView;
